import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-367bcc48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-site container-menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto-logo" }, " LimaTec ", -1))
const _hoisted_3 = { class: "menu-list" }
const _hoisted_4 = { class: "acoes-menu" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" })
], -1))
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<svg class=\"quando-escuro\" viewBox=\"0 0 24 24\" width=\"20\" height=\"20\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" data-v-367bcc48><circle cx=\"12\" cy=\"12\" r=\"4\" data-v-367bcc48></circle><path d=\"M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5L19 19M5 19l1.5-1.5M17.5 6.5L19 5\" data-v-367bcc48></path></svg><svg class=\"quando-claro\" viewBox=\"0 0 24 24\" width=\"20\" height=\"20\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" data-v-367bcc48><path d=\"M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z\" data-v-367bcc48></path></svg>", 2)
const _hoisted_9 = [
  _hoisted_7
]
const _hoisted_10 = ["title"]
const _hoisted_11 = ["aria-expanded"]
const _hoisted_12 = {
  key: 0,
  viewBox: "0 0 24 24",
  width: "22",
  height: "22",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "aria-hidden": "true"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M4 7h16M4 12h16M4 17h16" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  viewBox: "0 0 24 24",
  width: "22",
  height: "22",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "aria-hidden": "true"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M6 6l12 12M18 6L6 18" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "menu-celular"
}
const _hoisted_19 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoLimaTec = _resolveComponent("LogoLimaTec")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["main-menu", { 'menu-rolado': _ctx.rolado, 'menu-escondido': _ctx.escondido }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        href: "#inicio",
        class: "imagem-texto",
        "aria-label": "Voltar ao início",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.irPara('inicio')), ["prevent"]))
      }, [
        _createVNode(_component_LogoLimaTec, { Altura: "46px" }),
        _hoisted_2
      ]),
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("a", {
          class: _normalizeClass(["item-menu", { 'item-ativo': _ctx.secaoAtiva === 'empresa' }]),
          href: "#empresa",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.irPara('empresa')), ["prevent"]))
        }, " Sobre nós ", 2),
        _createElementVNode("a", {
          class: _normalizeClass(["item-menu", { 'item-ativo': _ctx.secaoAtiva === 'servicos' }]),
          href: "#servicos",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.irPara('servicos')), ["prevent"]))
        }, " Serviços ", 2),
        _createElementVNode("a", {
          class: _normalizeClass(["item-menu", { 'item-ativo': _ctx.secaoAtiva === 'orcamento' }]),
          href: "#orcamento",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.irPara('orcamento')), ["prevent"]))
        }, " Orçamento ", 2),
        _createElementVNode("a", {
          class: _normalizeClass(["item-menu", { 'item-ativo': _ctx.secaoAtiva === 'contato' }]),
          href: "#contato",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.irPara('contato')), ["prevent"]))
        }, " Contato ", 2)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          class: "telefone-menu",
          href: _ctx.telefoneHref
        }, [
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.telefone), 1)
        ], 8, _hoisted_5),
        _createElementVNode("button", {
          class: "botao-tema",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('alternar-tema'))),
          "aria-label": "Alternar entre modo escuro e claro",
          title: "Alternar modo escuro / claro"
        }, _hoisted_9),
        _createElementVNode("button", {
          class: "botao-pilula botao-contato",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.abrirWhatsApp())),
          title: _ctx.TextoWhatsApp
        }, " Entrar em contato ", 8, _hoisted_10),
        _createElementVNode("button", {
          class: "botao-hamburguer",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.menuAberto = !_ctx.menuAberto)),
          "aria-expanded": _ctx.menuAberto,
          "aria-label": "Abrir menu"
        }, [
          (!_ctx.menuAberto)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_14))
            : (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_17))
        ], 8, _hoisted_11)
      ])
    ]),
    (_ctx.menuAberto)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_18, [
          _createElementVNode("a", {
            href: "#empresa",
            onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.irPara('empresa')), ["prevent"]))
          }, " Sobre nós "),
          _createElementVNode("a", {
            href: "#servicos",
            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.irPara('servicos')), ["prevent"]))
          }, " Serviços "),
          _createElementVNode("a", {
            href: "#orcamento",
            onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.irPara('orcamento')), ["prevent"]))
          }, " Orçamento "),
          _createElementVNode("a", {
            href: "#contato",
            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.irPara('contato')), ["prevent"]))
          }, " Contato "),
          _createElementVNode("a", {
            href: _ctx.telefoneHref,
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.menuAberto = false)),
            class: "telefone-celular"
          }, " Ligar: " + _toDisplayString(_ctx.telefone), 9, _hoisted_19)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}